import { render, staticRenderFns } from "./base-receipt.vue?vue&type=template&id=c233b146"
import script from "./base-receipt.vue?vue&type=script&lang=js"
export * from "./base-receipt.vue?vue&type=script&lang=js"
import style0 from "./base-receipt.vue?vue&type=style&index=0&id=c233b146&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports